export default function ForbidIcon() {
  return (
    <svg width='16' height='20' viewBox='0 0 16 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1391_2489)'>
        <path
          d='M8 17C11.866 17 15 13.866 15 10C15 6.13401 11.866 3 8 3C4.13401 3 1 6.13401 1 10C1 13.866 4.13401 17 8 17Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3 15L13 5'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1391_2489'>
          <rect width='16' height='16' fill='white' transform='translate(0 2)' />
        </clipPath>
      </defs>
    </svg>
  )
}
